
import Vue from 'vue';
import Podcast from '@root/modules/podcast/components/fragments/Podcast.vue';
import { MediaData, Podcast as IPodcast } from '@root/modules/podcast/types/podcast';
import getPodcastWithHref from '@root/modules/podcast/utils/getPodcastWithHref';
import Swiper from '@core/components/UI/swiper/Swiper.vue';
import LinkHandler from '@core/components/helpers/LinkHandler.vue';
import isMobileView from '@root/common/utils/isMobileView';
import getMediaData from '@root/modules/podcast/utils/getMediaData';

interface Props {
  data: IPodcast[];
}

interface Data {
  isMobileView: boolean;
  swiperOptions: Record<string, any>;
  mediaData: MediaData[] | null;
}

interface Computed {
  items: IPodcast[];
}

interface Methods {
  getMediaData: () => Promise<MediaData[] | null>;
  addVideoData: (podcast: IPodcast) => IPodcast;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Podcast,
    Swiper,
    LinkHandler,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isMobileView: false,
      swiperOptions: {
        spaceBetween: 24,
        initialSlide: 0,
        autoplay: false,
        loop: false,
        slidesPerView: 2.5,
        slidesPerGroup: 1,
        pagination: {
          enabled: false,
        },
        navigation: {
          enabled: false,
        },
        scrollbar: {
          enabled: false,
        },
        simulateTouch: false,
        breakpoints: {
          768: {
            freeMode: false,
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          1230: {
            freeMode: false,
            slidesPerView: 6,
            slidesPerGroup: 6,
          },
        },
      },
      mediaData: null,
    };
  },
  computed: {
    items() {
      let data = [...this.data];

      if (this.data.length) {
        const fakeDomainEnabled = this.$config.FAKE_DOMAIN_ENABLED;
        const podcastsWithHref = data.map((podcast: IPodcast) => {
          const { domain } = this.$channelConfig('settings');
          return getPodcastWithHref({ podcast, domain, fakeDomainEnabled });
        });

        data = podcastsWithHref;
      }

      return data;
    },
  },
  methods: {
    async getMediaData() {
      return await getMediaData(this.data, null, false);
    },
    addVideoData(podcast: IPodcast) {
      const video = this.mediaData?.find((mediaDataItem) => mediaDataItem.id === podcast.id)?.video || undefined;

      return { ...podcast, video };
    },
  },
  async mounted() {
    this.isMobileView = isMobileView();
    this.mediaData = await this.getMediaData();
  },
});
